import React from 'react';
import I18n from 'utils/I18n';
import clsx from '@strava/ui/clsx';
import { trackV2 } from 'utils/analytics';

import {
  setMonthlyDuration,
  setYearlyDuration
} from '../../../state/Checkout.actions';
import { useCheckoutContext } from '../../../state/CheckoutContext';
import { getStyles as _getStyles } from '../../../utils/checkoutUtils';

import styles from './DurationSelectSideBySide.scss';

export const I18nPrefix = 'strava.subscriptions.checkout.summary.organic';

export const DurationSelectSideBySide = () => {
  const { checkoutEntityState, dispatch } = useCheckoutContext();

  const {
    analyticsData,
    checkoutSubmitting,
    duration,
    products,
    promoCodeSubmitting,
    yearlyPercentOff,
    experiments
  } = checkoutEntityState;

  const disabled =
    checkoutSubmitting || promoCodeSubmitting || products?.promotion?.full;

  const { shouldShowPromoOnTrial } = experiments;

  const getStyles = (style) =>
    _getStyles(styles, style, shouldShowPromoOnTrial);

  const handleDurationChange = ({ durationSelected, dispatchAction }) => {
    trackV2({
      category: 'summit_upsell',
      page: 'cart',
      action: 'change_duration',
      properties: {
        ...analyticsData,
        duration: durationSelected,
        subscription_type: 'organic'
      }
    });

    dispatch(dispatchAction());
  };

  return (
    <div className={clsx('btn-group', getStyles('durationSelect'))}>
      <label
        className={clsx('btn', 'btn-default', styles.durationBtn)}
        htmlFor="duration-yearly"
      >
        <input
          id="duration-yearly"
          type="radio"
          name="duration"
          checked={duration === 'yearly'}
          disabled={disabled}
          onChange={() =>
            handleDurationChange({
              durationSelected: 'yearly',
              dispatchAction: setYearlyDuration
            })
          }
        />
        <p className={styles.durationText}>
          {I18n.t(`${I18nPrefix}.yearly`)}
          <span className={styles.yearlyPercentOff}>
            {I18n.t(`${I18nPrefix}.saving`, {
              percent: Math.round(yearlyPercentOff)
            })}
          </span>
        </p>
      </label>
      <label
        className={clsx('btn', 'btn-default', styles.durationBtn)}
        htmlFor="duration-monthly"
      >
        <input
          id="duration-monthly"
          type="radio"
          name="duration"
          checked={duration === 'monthly'}
          disabled={disabled}
          onChange={() =>
            handleDurationChange({
              durationSelected: 'monthly',
              dispatchAction: setMonthlyDuration
            })
          }
        />
        <p className={styles.durationText}>{I18n.t(`${I18nPrefix}.monthly`)}</p>
      </label>
    </div>
  );
};

export default DurationSelectSideBySide;
